(function () {
  function initBar(bar) {
    var target = bar.dataset.observeSelector ? document.querySelector(bar.dataset.observeSelector) : null;

    var isVisible = false;
    var endTime = bar.dataset.countdownEnd ? new Date(bar.dataset.countdownEnd).getTime() : NaN;

    // Com countdown configurado e já encerrado, o componente inteiro fica oculto.
    function isExpired() {
      return !isNaN(endTime) && endTime <= Date.now();
    }

    if (isExpired()) {
      bar.hidden = true;
      return;
    }

    // Publica a altura da barra para que outros elementos fixos (ex.: carrinho flutuante) subam junto.
    function updateHeight(visible) {
      isVisible = visible;
      document.documentElement.style.setProperty('--bf-sticky-bar-height', visible && window.innerWidth < 1550 ? bar.offsetHeight + 'px' : '0px');
    }

    window.addEventListener('resize', function () {
      if (isVisible) updateHeight(true);
    });

    function setVisible(visible) {
      if (isExpired()) {
        visible = false;
        bar.hidden = true;
      }
      bar.classList.toggle('is-visible', visible);
      updateHeight(visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if (!target || !('IntersectionObserver' in window)) return;

    if (!isNaN(endTime)) {
      var expiryTimer = setInterval(function () {
        if (!isExpired()) return;
        clearInterval(expiryTimer);
        setVisible(false);
      }, 1000);
    }

    // Exibe a barra somente depois que o usuário passou da seção observada.
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(target);
  }

  function init() {
    document.querySelectorAll('[data-bf-sticky-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
